import ListProcesses from "@/views/packing_house/quality_control/query_container/ListProcesses.vue";
import ListContainers from "@/views/packing_house/quality_control/query_container/ListContainers.vue";
import ListTemplates from "@/views/packing_house/quality_control/query_container/ListTemplates.vue";
import ListQualityInspects from "@/views/packing_house/quality_control/query_container/ListQualityInspects.vue";
import ShowQualityInspect from "@/views/packing_house/quality_control/query_container/ShowQualityInspect.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ph",
  role: "quality_control",
  permission: "query_container",
});

export default [
  {
    path: "/ph/:packing_house_id/quality_control/query_container/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_control/query_container/list_containers/:packing_house_process_id",
    name: routeName("list_containers"),
    component: ListContainers,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_control/query_container/list_templates/:packing_house_process_id/:container_id",
    name: routeName("list_templates"),
    component: ListTemplates,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_control/query_container/list_quality_inspects/:packing_house_process_id/:container_id/:quality_template_id",
    name: routeName("list_quality_inspects"),
    component: ListQualityInspects,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_control/query_container/show_quality_inspect/:packing_house_process_id/:container_id/:quality_template_id/:quality_inspect_id",
    name: routeName("show_quality_inspect"),
    component: ShowQualityInspect,
    props: true,
    meta: META
  }
];
